import { render, staticRenderFns } from "./PromoExceptions.vue?vue&type=template&id=f341275e&scoped=true"
import script from "./PromoExceptions.vue?vue&type=script&lang=js"
export * from "./PromoExceptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f341275e",
  null
  
)

export default component.exports